import axios from "axios";

// export  async function getApgJWT() {
//   try {
//     const cachedToken = localStorage.getItem("apg_jwt");
//     const tokenExpiry = localStorage.getItem("apg_jwt_expiry");

//     console.log("cached token:", cachedToken);
//     console.log("TokenExpiry (stored):", tokenExpiry);
//     console.log("Current Time (Now):", Date.now());

//     if (cachedToken && tokenExpiry && Date.now() < parseInt(tokenExpiry)) {
//       console.log("Using Cached token (still valid)");
//       return cachedToken;
//     }
//     console.log("Fetching n c apg token");
//     const response = await axios.post(
//       process.env.REACT_APP_JWT_URL,
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       },
//       {
//         auth: {
//           username: process.env.REACT_APP_JWT_USERNAME,
//           password: process.env.REACT_APP_JWT_PASSWORD,
//         },
//       }
//     );

//     const newToken = response.data.token;
//     // const expiresIn = response.data.expires_in || 800000 // ~14 mins to refresh
//     const expiresIn = 500; //900 is 15 mins

//     localStorage.setItem("apg_jwt", newToken);
//     localStorage.setItem("apg_jwt_expiry", Date.now() + expiresIn * 1000);

//     return newToken;
//   } catch (err) {
//     console.error("Failed to get APG JWT:", err);
//     throw err;
//   }
// }

export async function getApgJWT() {
  try {
    console.log("Fetching fresh APG JWT...");
    const response = await axios.post(
      process.env.REACT_APP_JWT_URL,
      {}, // empty body
      {
        headers: {
          "Content-Type": "application/json",
        },
        auth: {
          username: process.env.REACT_APP_JWT_USERNAME,
          password: process.env.REACT_APP_JWT_PASSWORD,
        },
      }
    );
    if (!response.data || !response.data.token) {
      throw new Error("APG JWT response missing token");
    }
    const newToken = response.data.token;
    console.log("APG JWT received successfully");
    return newToken;
  } catch (err) {
    console.error("Failed to get APG JWT:", err);
    throw err;
  }
 }